import { Accordion } from 'accordion'
import 'accordion/src/accordion.css'

export default container => {
  container.querySelectorAll('.accordion').forEach(wrapper => {
    new Accordion(wrapper)
  })

  container.querySelectorAll('[data-change-bg-on-click]').forEach(el => {
    el.addEventListener('click', () => {
      const pageSection = el.closest('.page-section')
      if (pageSection) {
        const bg = pageSection.querySelector('.page-section__bg')
        if (bg) {
          bg.style.backgroundImage = `${el.dataset.changeBgOnClick}`
        }
      }
    })
  })
}
